import { on } from '@ngrx/store';
import { AsyncActions, ShowTagsActions } from './show-tags.actions';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const showTagsFeatureKey = 'showTags';

export interface ShowTagsState {
    showTags: string
}

export const initialState: ShowTagsState = {
    showTags: 'true',
    ...asyncActionState.initial
};

const { loadActions, successActions, errorActions } = AsyncActions;

export const showTagsReducer = withLoadables<ShowTagsState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(ShowTagsActions.init, (state: ShowTagsState) => ({
        ...state,
        showTags: state.showTags
    })),

    on(ShowTagsActions.selectShowTags, (state: ShowTagsState, { showTags }) => ({
        ...state,
        showTags
    }))

);
